import { GifOverlayProps } from '@giphy/react-components'
import React from 'react'
import { getExplorePath } from 'shared/util/search'
import styled from 'styled-components'

const TagOverlayContainer = styled.div<{ isHovered: boolean }>`
    position: absolute;
    bottom: 0;
    color: white;
    justify-content: flex-start;
    align-items: flex-end;
    font-size: 12px;
    white-space: nowrap;
    padding: 4px;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    background: linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, rgba(18, 18, 18, 0.5) 100%);
    opacity: ${props => (props.isHovered ? 1 : 0)};
    transition: opacity 300ms;
`
const Tag = ({ tag }: { tag: string }) => {
    return (
        <span
            onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                const path = getExplorePath(tag)
                if (e.metaKey) {
                    window.open(`${location.origin}${path}`)
                } else {
                    location.href = path
                }
            }}
        >
            #{tag}
            &nbsp;
        </span>
    )
}
const mapTags = (tags: string[] = []) => tags.map(tag => (tag ? <Tag tag={tag} key={tag} /> : ''))
const TagOverlay = ({ gif, isHovered }: GifOverlayProps) => (
    <TagOverlayContainer isHovered={isHovered}>{mapTags(gif.tags.slice(0, 2))}</TagOverlayContainer>
)

export default TagOverlay
